export class Backgroundsky{

    private sky:PIXI.Sprite;
    private container:PIXI.Container;

    constructor(parent:PIXI.Container,app:PIXI.Application)
    {


        let placeHolderbg = new PIXI.Graphics()
        placeHolderbg.beginFill(0xff0000);
        placeHolderbg.drawRect(0, 0, 1, 1);
        placeHolderbg.endFill();
        placeHolderbg;    
        
        var placeHolder_texture = app.renderer.generateTexture(placeHolderbg);
        // var placeHolder_texture = placeHolderbg.generateTexture();//app.renderer.generateTexture(placeHolderbg);
        this.container= new PIXI.Container();
        this.sky=new PIXI.Sprite(placeHolder_texture);    
        this.container.addChild(this.sky);
        parent.addChild(this.container);
        this.sky.alpha=1;
    }
   

    public getImageBg=():PIXI.Sprite=>
    {
        return this.sky;
    }
    public setNewTexture=(newTexture:string):void=>
    {
        this.sky.texture=PIXI.Texture.fromFrame(newTexture);
    }
    public getParent=():PIXI.Container=>
    {
        return this.container;
    }

}